export default __webpack_public_path__ + "static/media/R5C_8087.bae30db4.jpg";